import { PrismicError } from "./PrismicError.js";
class ParsingError extends PrismicError {
}
export {
  ParsingError
};
//# sourceMappingURL=ParsingError.js.map
